import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getShippingList(params) {
  return request({
    url: URL.partner.shipping,
    method: 'get',
    params
  })
}

export function saveShipping(data) {
  return request({
    url: URL.partner.shipping,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delShipping(uuid) {
  return request({
    url: URL.partner.shipping + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 船公司信息分页查询
export function shipCompanySelectPage(data) {
  return request({
    url: `${URL.partner.shipCompanySelectPage}`,
    method: 'post',
    data
  })
}

// 新增船公司信息
export function addShipCompany(data) {
  return request({
    url: `${URL.partner.addShipCompany}`,
    method: 'post',
    data
  })
}

// 更新船公司信息
export function updateShipCompany(data) {
  return request({
    url: `${URL.partner.updateShipCompany}`,
    method: 'post',
    data
  })
}

export function deleteShipCompany(data) {
  return request({
    url: `${URL.partner.deleteShipCompany}`,
    method: 'post',
    data
  })
}

export function getAllShipCompany() {
  return request({
    url: `${URL.partner.getAllShipCompany}`,
    method: 'get'
  })
}
export function matchEori(params) {
  return request({
    url: `${URL.partner.matchEori}`,
    method: 'get',
    params
  })
}

export function matchEoriByEns() {
  return request({
    url: `${URL.partner.matchEoriByEns}`,
    method: 'get'
  })
}
export function getByUuidShipCompany(params) {
  return request({
    url: `${URL.partner.getByUuidShipCompany}`,
    method: 'get',
    params
  })
}
